import PageContainer from '@/components/Container/PageContainer';
import SharedDocumentsList from '@/components/DocumentsShared';

const DocumentsShared = () => {
  return (
    <PageContainer title={'Files shared with me'}>
      <div style={{ width: '100%', maxWidth: '1200px', background: '#ffffff', padding: '30px 40px', borderRadius: 15 }}>
        <SharedDocumentsList />
      </div>
    </PageContainer>
  );
};

export default DocumentsShared;
